import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes';
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
    // base: '/frontpage2/',
    fallback: false,
    mode: 'history',
    routes,
})


// WEBPACK FOOTER //
// ./src/router/index.js